// Imports
var ___CSS_LOADER_API_IMPORT___ = require("../../../../../node_modules/css-loader/dist/runtime/api.js");
exports = ___CSS_LOADER_API_IMPORT___(false);
// Module
exports.push([module.id, ".text-box[data-v-a3c07abc] {\n  width: 100%;\n  background: #fff;\n  padding: 11px 10px 11px 12px;\n  font-size: 15px;\n  color: #333;\n  border-bottom: 1px solid #eee;\n}\n.text-box .title[data-v-a3c07abc] {\n  width: 95px;\n}\n.text-box .textVal[data-v-a3c07abc] {\n  width: 250px;\n  text-align: right;\n}\n.text-box .textVal .place[data-v-a3c07abc] {\n  font-weight: 400;\n  color: #cccccc;\n}", ""]);
// Exports
module.exports = exports;
